export default __webpack_public_path__ + "static/media/share.cbc46392.svg";